module.exports = __webpack_public_path__ + "assets/img/vs-badge.96e1064f.png";